<template>
  <div class="p-4 pb-3">
    <div class="flex gap-2 border px-4 pt-6 pb-5 rounded-xl overflow-hidden relative" :class="[$theme.lightButtonBg, $theme.borderOrange]">
      <div class="w-full h-2 absolute top-0 left-0 bg-orange"></div>
      <NotificationIcon />
      <div :class="$theme.baseTextColor">
        <h4 class="font-medium">{{ $t('emergency_alert_title') }}</h4>
        <ul class="list-decimal opacity-60 py-2 pl-5">
          <li v-if="list_errors.tariff_selected" class="text-sm">{{ $t('select_tariff_alert') }}</li>
          <li v-if="list_errors.tariff_expired" class="text-sm ">{{ $t('tariff_expired_alert') }}</li>
          <li v-if="list_errors.signals_disabled" class="text-sm">{{ $t('enable_signals_alert') }}</li>
          <li v-if="list_errors.exchange_disconnected" class="text-sm">{{ $t('exchange_disconnected_alert') }}</li>
          <li v-if="list_errors.balance_unavailable" class="text-sm">{{ $t('balance_unavailable_alert') }}</li>
        </ul>
        <router-link to="/setting" class="flex items-center gap-1" :class="[ $theme.textOrange]">
          <span class="underline">{{ $t('settings') }}</span>
          <span aria-hidden="true"> &rarr;</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationIcon from "@/components/icons/NotificationIcon.vue";

export default {
  props: ['list_errors'],
  components: {
    NotificationIcon
  },
}
</script>